import { Pushbutton } from '@stratumn/atomic';

import { Box, ChangePassword, Logo } from 'components/ui';
import { ROUTE_LOGIN, ROUTE_MY_PROFILE } from 'constant/routes';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import qs from 'query-string';
import React from 'react';
import injectSheet from 'react-jss';
import { Link, withRouter } from 'react-router-dom';
import { SpanType, withSpanAsync } from 'tracing';
import { withRestClient } from 'wrappers';

import styles from './reset.style';

export class Reset extends React.PureComponent {
  static propTypes = {
    classes: PropType.object.isRequired,
    location: PropType.object.isRequired,
    history: PropType.object.isRequired,
    client: PropType.object.isRequired
  };

  state = {
    password: null,
    submitted: false
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handlePasswordChange = password => this.setState({ password });

  isActive() {
    const { submitted, password } = this.state;
    return !submitted && !!password;
  }

  resetPassword = async () =>
    withSpanAsync('reset', SpanType.processing, async () => {
      const { password } = this.state;
      const { invitationToken } = qs.parse(this.props.location.search);
      this.setState({ submitted: true });
      try {
        await this.props.client.reset(password, invitationToken);
        this.props.history.push(ROUTE_MY_PROFILE);
      } catch (err) {
        this.setState({ submitted: false });
      }
    });

  render() {
    const { classes } = this.props;
    return (
      <>
        <Logo />
        <Box title="Reset your password">
          <ChangePassword
            data-testid="password-input"
            onChange={this.handlePasswordChange}
          />
          <Pushbutton
            data-testid="reset-password-button"
            disabled={!this.isActive()}
            onClick={this.resetPassword}
            primary
          >
            change password
          </Pushbutton>
          <Link
            className={classes.backToSignIn}
            data-testid="back-to-login"
            to={ROUTE_LOGIN}
          >
            Back to log in
          </Link>
        </Box>
      </>
    );
  }
}

export default compose(withRouter, withRestClient, injectSheet(styles))(Reset);
